import React, { useEffect, useState } from "react"
import { apiUrl } from "../../api"
import "./day.css"

const fallbackDays = [
     { iconday: 3, iconnight: 33, maxtemp: 28, mintemp: 21 },
     { iconday: 32, iconnight: 34, maxtemp: 29, mintemp: 22 },
     { iconday: 6, iconnight: 35, maxtemp: 27, mintemp: 21 },
     { iconday: 12, iconnight: 39, maxtemp: 26, mintemp: 20 },
     { iconday: 18, iconnight: 41, maxtemp: 25, mintemp: 20 }
]

const Day = () => {
     const [days, setDays] = useState(fallbackDays)

     useEffect(() => {
          fetch(apiUrl("/controller/weatherdays/"), {
               method: "GET",
          })
               .then((data) => {
                    if (!data.ok) {
                         throw new Error("Weather API unavailable")
                    }
                    return data.json()
               })
               .then((text) => {
                    if (Array.isArray(text) && text.length >= 5) {
                         setDays(text)
                    }
               })
               .catch(() => {
                    setDays(fallbackDays)
               })
     }, [])

     return (
          <div className="iconsday">
               {days[4] && (
                    <div className="card auth-card input-field">
                         <div className="weatherdaygridicon">
                              {days.slice(0, 5).map((day, index) => (
                                   <div className="dayforecastitem" key={index}>
                                        <span className="weekdaylabel">{getWeekdayLabel(index)}</span>
                                        <span className="dayicons">
                                             <span className="icon">{getIcon(day.iconday)}</span>
                                             <span className="icon nighticon">{getIcon(day.iconnight)}</span>
                                        </span>
                                   </div>
                              ))}
                         </div>
                    </div>
               )}
          </div>
     )
}

const getWeekdayLabel = (index) => {
     const date = new Date()
     date.setDate(date.getDate() + index)

     if (index === 0) {
          return "Heute"
     }

     return date.toLocaleDateString("de-AT", {
          weekday: "short",
     }).replace(".", "")
}

const getIcon = (value) => {
     switch (value) {
          case 1:
          case 2:
          case 32:
               return <div className="iconsunny"></div>
          case 3:
          case 4:
               return <div className="iconcloudsandsun"></div>
          case 6:
          case 26:
               return <div className="iconmostlycloudy"></div>
          case 7:
          case 38:
               return <div className="iconcloudy"></div>
          case 12:
               return <div className="iconshowers"></div>
          case 13:
          case 14:
               return <div className="iconmostlycloudywsun"></div>
          case 15:
          case 41:
          case 42:
               return <div className="iconstorm"></div>
          case 16:
          case 17:
               return <div className="iconstormwithsun"></div>
          case 18:
          case 39:
          case 40:
               return <div className="iconrain"></div>
          case 19:
          case 25:
          case 29:
          case 43:
               return <div className="iconflurries"></div>
          case 20:
          case 21:
          case 23:
               return <div className="iconsunwflurries"></div>
          case 22:
          case 24:
          case 31:
               return <div className="iconsnowy"></div>
          case 30:
               return <div className="iconhot"></div>
          case 33:
          case 34:
               return <div className="iconmostlyclear"></div>
          case 35:
          case 36:
               return <div className="iconmostlycloudynight"></div>
          default:
               return <div className="iconcloudy"></div>
     }
}

export default Day
